import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=5a74f6e2"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=5a74f6e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports